var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("new-enterprise-modal", {
        attrs: {
          showCreateAccount: _vm.showCreateAccount,
          ownerId: _vm.idAccount,
          itemId: _vm.enterpriseId,
          clean: _vm.clean,
          type: _vm.type
        },
        on: {
          close: _vm.closeEnterpriseModal,
          error: _vm.handleError,
          "enterprise-created": _vm.updateNewAccount,
          cleaned: function($event) {
            _vm.clean = false
          },
          "Account-updated": _vm.accountUpdated
        }
      }),
      _c(
        "base-header",
        {
          staticClass: "pb-6 pb-8 pt-5 pt-md-8",
          attrs: { type: "gradient-primary" }
        },
        [
          _vm.isUserAccount
            ? _c("card-stats", { attrs: { period: _vm.period } })
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "container-fluid mt--7" }, [
        _c("div", { staticClass: "row mt-5" }, [
          _c(
            "div",
            { staticClass: "col-xl-12" },
            [
              _c("enterprises-table", {
                attrs: {
                  idAccount: _vm.idAccount,
                  updateTable: _vm.updteTable,
                  type: _vm.type
                },
                on: {
                  "table-loaded": _vm.tableLoaded,
                  "new-item": _vm.newItem,
                  error: _vm.handleError,
                  "update-item": _vm.prepareUpdateItem
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }